module.exports = __webpack_public_path__ + "static/media/queue.f4fcfb4c.svg";